import React from "react";
import BoxShadow from "../../../../../../Common/Components/BoxShadow";
import { useCreateTimeTable } from "../Hooks";
import { Spinner } from "react-bootstrap";
import CardTime from "./TimeComponents/Card";
import { TbAlertTriangle } from "react-icons/tb";
import { Day } from "../../../../../../Common/Function";
import EditComponent from "./TimeComponents/EditCell";
const SubmitTimes = ({ form, setForm, inputs }) => {
  const { sendNewData, loading } = useCreateTimeTable();
  const filterData = form => {
    if (form.option.needdate) {
      // let times = {};
      // Object.keys(form.times).map(day => {
      //   times = { [day]: [] };
      //   form.times[day].map(time => {
      //     const { _id, starts, ends, ...otherData } = time;
      //     times[day.toString()] = [...times[day.toString()], otherData];
      //   });
      // });

      return {
        ...form,
      };
    } else {
      return {
        ...form,
        show_model: "list",
        times: form.times.map(time => {
          const { _id, starts, ends, ...otherData } = time;
          return { ...otherData };
        }),
      };
    }
  };
  if (form.option.needdate) {
    if (form.show_model == "list") {
      return (
        <>
          <div className="row mt-3">
            <div className="col">
              {form.times &&
                !Array.isArray(form.time) &&
                Object.keys(form.times).map((day, key) => {
                  return (
                    <div key={key}>
                      <h6>{Day(day)}</h6>
                      <div className="row">
                        {form.times[day].map((time, count) => {
                          return (
                            <CardTime
                              // deleteItem={deleteTime}
                              key={count}
                              time={time}
                              options={form.option}
                            />
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              {/* <button
              className="btn"
              onClick={() => sendNewData(filterData(form))}
            >
              ارسال
            </button> */}
            </div>
          </div>
          <BoxShadow
            style={{
              padding: "10px",
              margin: "0",
              marginTop: "20px",
            }}
          >
            <div className="row justify-content-between">
              <div className="col">
                <h6 className="d-flex align-items-center">
                  <TbAlertTriangle
                    color="#FBDC0B"
                    style={{
                      marginLeft: "5px",
                    }}
                  />
                  در صورت مورد تایید بودن زمان بندی دکمه ارسال را بزنید در غیر
                  این صورت{" "}
                  <span style={{ color: "#1976d2" }}> کلید بازگشت</span> را
                  بزنید
                </h6>
              </div>
              <div className="col-2 d-flex justify-content-end">
                <button
                  className="btn btn-primary"
                  onClick={() => sendNewData(filterData(form))}
                >
                  {loading.send ? (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    "ارسال"
                  )}
                </button>
              </div>
            </div>
          </BoxShadow>
        </>
      );
    } else {
      return (
        <>
          <BoxShadow style={{ margin: 0, padding: "10px", marginTop: "20px" }}>
            <div>
              <table class="table">
                <thead>
                  <tr>
                    <>
                      <th>#</th>
                      {console.log(Object.values(form.times.Friday))}
                      {Object.values(form.times.Friday).map((s, key) => {
                        return (
                          <th
                            className="text-center"
                            key={key}
                          >{`${s.start} تا ${s.end} `}</th>
                        );
                      })}
                    </>
                  </tr>
                </thead>
                <tbody>
                  {form.keys &&
                    form.keys.map((item, key) => {
                      return (
                        <tr key={key}>
                          <td>{Day(item)}</td>
                          {form.times[item].map((s, i) => {
                            return (
                              <td className="text-center" key={i}>
                                <EditComponent
                                  form={form}
                                  setForm={setForm}
                                  time={s}
                                  day={item}
                                  inputs={inputs}
                                  show={true}
                                />
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
            <div className="row justify-content-between">
              <div className="col">
                <h6 className="d-flex align-items-center">
                  <TbAlertTriangle
                    color="#FBDC0B"
                    style={{
                      marginLeft: "5px",
                    }}
                  />
                  در صورت مورد تایید بودن زمان بندی دکمه ارسال را بزنید در غیر
                  این صورت{" "}
                  <span style={{ color: "#1976d2" }}> کلید بازگشت</span> را
                  بزنید
                </h6>
              </div>
              <div className="col-2 d-flex justify-content-end">
                <button
                  className="btn btn-primary"
                  onClick={() => sendNewData(filterData(form))}
                >
                  {loading.send ? (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    "ارسال"
                  )}
                </button>
              </div>
            </div>
          </BoxShadow>
        </>
      );
    }
  } else {
    return (
      <>
        <div className="row mt-3">
          {form.times.map((time, key) => {
            return (
              <CardTime
                noBtn={true}
                time={time}
                options={form.option}
                key={key}
              />
            );
          })}
        </div>
        <BoxShadow
          style={{
            padding: "10px",
            margin: "0",
            marginTop: "20px",
          }}
        >
          <div className="row justify-content-between">
            <div className="col">
              <h6 className="d-flex align-items-center">
                <TbAlertTriangle
                  color="#FBDC0B"
                  style={{
                    marginLeft: "5px",
                  }}
                />
                در صورت مورد تایید بودن زمان بندی دکمه ارسال را بزنید در غیر این
                صورت <span style={{ color: "#1976d2" }}> کلید بازگشت</span> را
                بزنید
              </h6>
            </div>
            <div className="col-2 d-flex justify-content-end">
              <button
                className="btn btn-primary"
                onClick={() => sendNewData(filterData(form))}
              >
                {loading.send ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  "ارسال"
                )}
              </button>
            </div>
          </div>
        </BoxShadow>
      </>
    );
  }
};

export default SubmitTimes;
